export default "/images/3d1041b12ce02ca58ee786653f91be7a.avif";